//Get a list of all of the page numbers
export const getPageList = (currentPage: number, totalPages: number) => {
	let pageNumberArray = [];

	let startIndex = 0;

	if (currentPage >= 4) {
		startIndex = currentPage - 3;
	}

	if (startIndex < 1) {
		startIndex = 0;
	}

	let endIndex = currentPage + 5;
	if (endIndex >= totalPages) {
		endIndex = totalPages;
	}

	for (var i = startIndex; i < endIndex; i++) {
		pageNumberArray.push(i + 1);
	}

	if (pageNumberArray.length > 6) {
		return pageNumberArray.slice(0, 6);
	} else {
		return pageNumberArray;
	}
};
